import { createFileRoute } from "@tanstack/react-router"
import { AddOutlookIntegration } from "modules/settings/components/integrations/outlook/AddOutlookIntegration"
import { z } from "zod"

const OutlookIntegrationCallbackSearchSchema = z.object({
  code: z.string().optional(),
  error: z.string().optional(),
  error_description: z.string().optional(),
})

export const Route = createFileRoute("/_base/_auth/settings/channels/outlook/new")({
  component: AddOutlookIntegration,
  validateSearch: (search: Partial<z.infer<typeof OutlookIntegrationCallbackSearchSchema>>) => {
    return OutlookIntegrationCallbackSearchSchema.parse(search)
  },
})
